import { combineReducers } from "@reduxjs/toolkit";
import entities from "./entities";

export default combineReducers({ entities });
